import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Sharedservice } from './../shared.service';
import { MenuItem } from 'primeng/api';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { EngagementService } from 'src/app/services/engagement.service';
import { filter } from 'rxjs/operators';
import { UserService } from 'src/app/services/user.service';
import { UserModel } from 'src/app/models/user.model';
import { MasterHelpModel } from '../../models/MasterHelp.model';
import { MasterHelpService } from '../../services/masterhelp.service';
import { RegionService } from 'src/app/services/region.service';
import { EngagementModel } from 'src/app/models/engagement.model';
import { AdjustmentService } from '../../services/adjustment.service';
import { AdjustmentModel } from '../../models/adjustment.model';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { LanguageConstants } from '../constant';
import { environment } from 'src/environments/environment';
import { HelpvideosService } from 'src/app/services/helpvideos.service';
import { MsalService } from '@azure/msal-angular';
import { InfraService } from 'src/app/services/infra.service';
import { RegionModel } from 'src/app/models/region.model';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  private videoUrl: string;
  engagementId = '0';
  adjustmentID = '0';
  userName = '';
  currentitem: string;
  rootitem: string;
  display = false;
  viewproject: string;
  projectname = 'My Project';
  pageItemlist: any;
  items: MenuItem[];
  isRouterEventPerformed = false;
  region = '';
  currentRegion = '';
  regionId: number;
  isPrivacyPolicyAgreed: boolean;
  videoPopUpModel: boolean;
  videoPopUpModelSmall: boolean;
  isFromDaisey = false;
  viewProjectId = 9;
  isSessionExpired = false;
  isTempFlatfileUploaded: number;
  helpMenu: MasterHelpModel = new MasterHelpModel();
  helpMenu1: MasterHelpModel = new MasterHelpModel();
  helpMenu2: MasterHelpModel = new MasterHelpModel();
  show = false;
  pageName: string;
  activeIndex: number;
  helpVideoInputCheckBox = false;
  adjustmentPage = '';
  adjustmentName: string;
  currrentUserId: any;
  langCode: string;
  currLangTranslation: any;
  supportedLangs: any[] = [];
  applnLang: any;
  language:any;
  pnpEnglishHelpGuidURL: string = "https://discovercontent.ey.net/knd231232bryopdi";
  pnpSpanishHelpGuidURL: string = "https://discovercontent.ey.net/knd23123vlx27oyz";
  helpGuideEnglish: string = "https://eygb.sharepoint.com/:p:/r/sites/DiligenceWorkbenchSP/Shared%20Documents/User%20guides/DBA/DE_DBA_Detailed%20User%20Guide.pptx?d=w6efe6f8f88e64d9bb762cf5e27a0997c&csf=1&web=1&e=RlnoVK&xsdata=MDV8MDJ8U3VjaGl0cmEuSGFyaWdhbmVzaEBnZHMuZXkuY29tfDNmMWIzNTljZGI1ZDRiMjdkNDdkMDhkY2I2Mzc4NzA0fDViOTczZjk5NzdkZjRiZWJiMjdkYWEwYzcwYjg0ODJjfDB8MHw2Mzg1ODU1OTY4NTE3MDQ0Mjd8VW5rbm93bnxUV0ZwYkdac2IzZDhleUpXSWpvaU1DNHdMakF3TURBaUxDSlFJam9pVjJsdU16SWlMQ0pCVGlJNklrMWhhV3dpTENKWFZDSTZNbjA9fDB8fHw%3d&sdata=WVJQSGs5MStwMHlFNGJtZjg1ZEhRVm1od3A3TXdXZHljVXQ5VDl5T1dhUT0%3d";
  helpGuideSpanish: string = "https://eygb.sharepoint.com/:p:/r/sites/DiligenceWorkbenchSP/Shared%20Documents/User%20guides/DBA/DE_DBA_Detailed%20User%20Guide_Spanish.pptx?d=wf044115e13b84a68a39ba1b52ef60668&csf=1&web=1&e=aiRwNt&xsdata=MDV8MDJ8U3VjaGl0cmEuSGFyaWdhbmVzaEBnZHMuZXkuY29tfDE1NDBhM2Q3Yzk0YjQxNGE4NDQzMDhkY2MzODhlMGQ3fDViOTczZjk5NzdkZjRiZWJiMjdkYWEwYzcwYjg0ODJjfDB8MHw2Mzg2MDAyMzk5MjEyNTkzNTB8VW5rbm93bnxUV0ZwYkdac2IzZDhleUpXSWpvaU1DNHdMakF3TURBaUxDSlFJam9pVjJsdU16SWlMQ0pCVGlJNklrMWhhV3dpTENKWFZDSTZNbjA9fDB8fHw%3d&sdata=UWF6NG5TYXFmWjJlRkRQT0RoRGovOElVZkxqSGRBZzVHOEU1OFNlUndRWT0%3d";
  private videoService: HelpvideosService;
  private videoList: any;
  private introSrc: string;
  private videoSrc: string;
  private uploadSrc: string;
  private previewAttributeSrc: string;
  private userInputsSrc: string;
  private assessmentSrc: string;
  private accountmappingsSrc: string;
  private verificationSrc: string;
  private datacheckSrc: string;
  private schedulesSrc: string;
  private uploadDownloadSrc: string;
  private layoutCustomizationSrc: string;
  IsLanguageChange: boolean = false;
  @Output() languageChosen = new EventEmitter<string>();

  constructor(public sharedService: Sharedservice, private adalSvc: MsalService, private _router: Router,
    private location: Location, private route: ActivatedRoute, private _engagementservice: EngagementService,
    private masterHelpService: MasterHelpService, private regionService: RegionService, private userService: UserService,
    private adjustmentService: AdjustmentService, private translationService: TranslateService, private infraService : InfraService,
    private helpVideoService: HelpvideosService) {
    const infraDetails = localStorage.getItem('selectedInfra');
    const infraArr = infraDetails ? infraDetails.split(',') : [];
    this.regionId = infraArr.length > 2 ? parseInt(infraArr[2], 10) : 0;
    this.videoService = helpVideoService;

    this.setPageitemlist();

    this._router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.isRouterEventPerformed = true;
      this.setInitialRouting(location);
    });

    if (!this.isRouterEventPerformed) {
      this.setInitialRouting(this.location);
    }

    // this.infraService.currentRegion.subscribe(x=>{
    //   this.currentRegion = x;
    //   this.region = this.currentRegion;
    // });
   

  }

  
  getAllVideos() {
    this.IsLanguageChange = true;
    this.videoService.getAllVideos().subscribe((res: any) => {
      this.videoList = res;
      this.videoList.forEach(element => {
        switch (element.item1) {
          case "step1-upload": {
            this.uploadSrc = element.item2;
            break;
          }
          case "step2-preview-attributes": {
            this.previewAttributeSrc = element.item2;
            break;
          }
          case "step3-user-inputs": {
            this.userInputsSrc = element.item2;
            break;
          }
          case "step4-assesment": {
            this.assessmentSrc = element.item2;
            break;
          }
          case "step5-account-mappings": {
            this.accountmappingsSrc = element.item2;
            break;
          }

          case "step6-verification": {
            this.verificationSrc = element.item2;
            break;
          }
          case "step7-data-check": {
            this.datacheckSrc = element.item2;
            break;
          }
          case "step8-schedules": {
            this.schedulesSrc = element.item2;
            break;
          }
          case "intro": {
            this.introSrc = element.item2
            break;
          }

          case "upload-download-flat-file": {
            this.uploadDownloadSrc = element.item2;
            break;
          }

          case "DBA-Layout-Customization": {
            this.layoutCustomizationSrc = element.item2;
            break;
          }

          default: {
            this.videoUrl = "https://localhost:5200/nomatchfound";
            break;
          }
        }
      });
      this.IsLanguageChange = false;
    });

  }
  setInitialRouting(location) {
    let engId = '0';
    const firstChild = this.route.snapshot.root.firstChild;
    const countryId = firstChild?.paramMap?.get('countryId');
    if (countryId) {
      engId = firstChild.paramMap.get('id');
    }
    if (location.path() !== '') {
      this.pageName = location.path().split('/')[location.path().split('/').length - 1];
      if (this.pageName === 'home' || this.pageName === 'engagement' || this.pageName === "customizedlayouts") {
        const filteritem = this.pageItemlist.filter(x => x.id === location.path().split('/')[location.path().split('/').length - 1]);
        this.rootitem = filteritem[0].description;
        this.viewproject = '';
        this.currentitem = '';
        this.setProjectname(this.rootitem, location.path());
      } else {
        if (this.isNumber(this.pageName) && !countryId) {
          this.engagementId = location.path().split('/')[location.path().split('/').length - 1];
          this.pageName = location.path().split('/')[location.path().split('/').length - 2];
        } else if (this.pageName === 'add') {
          this.engagementId = location.path().split('/')[location.path().split('/').length - 3];
          this.pageName = location.path().split('/')[location.path().split('/').length - 3];
        } else if (this.pageName === 'uploaddatabook;src=qualitycheck') {
          const qualityCheckUrl = location.path().split('/')[location.path().split('/').length - 1];
          this.pageName = qualityCheckUrl.split(';')[qualityCheckUrl.split(';').length - 2];
          this.engagementId = location.path().split('/')[location.path().split('/').length - 2];
        } else if (this.isNumber(this.pageName) && countryId) {
          const pageNames = this.getPageName(this.route.snapshot.firstChild.url);
          this.engagementId = engId;
          this.pageName = (pageNames) ? pageNames : location.path().split('/')[location.path().split('/').length - 2];
        } else {
          this.engagementId = location.path().split('/')[location.path().split('/').length - 2];
          this.pageName = location.path().split('/')[location.path().split('/').length - 1];
        }

        if (this.pageName === 'analyticsreport') {
          this.currentitem = '';
          this.viewproject = '';
          this.rootitem = 'REPORTS';
          this.setProjectname(this.rootitem, location.path());
        } else {
          if (this.pageName.indexOf(';') > -1) {
            if (this.pageName.split(';').length > 0) {
              this.pageName = this.pageName.split(';')[0];
              this.engagementId = this.pageName.split(';')[1];
            }
          }
          const filteritem1 = this.pageItemlist.filter(x => x.id === this.pageName);
          this.rootitem = 'PROJECT MANAGEMENT';
          if (filteritem1.length > 0) {
            this.currentitem = filteritem1[0].description;
          } else {
            this.currentitem = '';
          }
          if (this.currentitem.toLowerCase() !== 'view project') {

            if (this.currentitem === 'Add project' || this.currentitem === 'Help') {
              this.viewproject = '';
            } else {
              this.viewproject = 'VIEW PROJECT';
            }
          } else {
            this.getmasterHelp();
            this.viewproject = '';
          }
          this.setProjectname(this.currentitem, location.path());
        }
      }
    }
     else {
      this.currentitem = '';
      this.rootitem = 'PROJECTS';
    }
  }

  onLangChange(lang: any) {
    const selectedLang = this.supportedLangs.filter(x=>x.Language == lang)[0];
   if (selectedLang.IsActive) {

      this.userService.UpdateUserLanguage(this.currrentUserId, selectedLang.ISOCode).subscribe();
      this.languageChosen.emit(selectedLang.ISOCode);
    } else {
      //event.stopPropagation();
    }
  }

  ngOnInit() {
    this.userService.GetAllVisibleLanguages().subscribe(data => {
      this.supportedLangs = data;
      this.userService.captureUserProfile().subscribe(userData => {
        this.currrentUserId = userData[0].Id;
        this.userName = userData[0].GivenName + ' ' + userData[0].FamilyName;
        this.applnLang = this.supportedLangs.filter(x => x.ISOCode === userData[0].ISOCode)[0];
        this.language = this.applnLang.Language;
        console.log(this.supportedLangs,'lang');
        this.languageChosen.emit(this.applnLang.ISOCode);
      })
    });

    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    setTimeout(() => {
    this.currLangTranslation = this.translationService.translations[this.langCode];
    if (localStorage.getItem('dProjectId')) {
      this.isFromDaisey = true;
      this.items = [{
        items: [
          { id: 'userName', label: this.userName, icon: 'pi pi-fw fa fa-user' },
          { id: 'logout', label: this.currLangTranslation.navbar.logout, icon: 'pi pi-fw fa fa-power-off', command: () => this.logout() }
        ]
      },
      ];
    } else {
      this.items = [{
        items: [
          { id: 'userName', label: this.userName, icon: 'pi pi-fw fa fa-user' },
          { id: 'changeRegion', label: this.currLangTranslation.navbar.changeRegion, icon: 'pi pi-fw fa fa-toggle-off', command: () => this.changeregion() },
          { id: 'logout', label: this.currLangTranslation.navbar.logout, icon: 'pi pi-fw fa fa-power-off', command: () => this.logout() }
        ]
      },
      ];
    }
  }, 1000);
    this.activeIndex = this.sharedService.getLocalStorageValueByName('activeindex');
    
    setTimeout(() => {
    const selectedRegion = localStorage.getItem('selectedInfra');
    if (!selectedRegion) {
      this.region = '';
      return;
    }

    const region = selectedRegion.split(',');
    if (region.length < 3 || !region[2]) {
      this.region = '';
      return;
    }

    this.regionId = parseInt(region[2], 10);
      this.regionService.getRegions().subscribe((data: RegionModel[])=> {
        const regionData = data.find(x => x.Id === this.regionId);
        if(regionData != undefined){
          this.region = regionData.Name;
        }
      
      });
    },1000);

    this.getAllVideos();
    this.translationService.onLangChange.subscribe((langEvent: LangChangeEvent) => {

      this.currLangTranslation = langEvent.translations;
      this.getAllVideos();
      this.updateItemsCollection();
      this.getmasterHelp1();
      if (localStorage.getItem('dProjectId')) {
        this.isFromDaisey = true;
        this.items = [{
          items: [
            { id: 'userName', label: this.userName, icon: 'pi pi-fw fa fa-user' },
            { id: 'logout', label: this.currLangTranslation.navbar.logout, icon: 'pi pi-fw fa fa-power-off', command: () => this.logout() }
          ]
        },
        ];
      } else {
        this.items = [{
          items: [
            { id: 'userName', label: this.userName, icon: 'pi pi-fw fa fa-user' },
            { id: 'changeRegion', label: this.currLangTranslation.navbar.changeRegion, icon: 'pi pi-fw fa fa-toggle-off', command: () => this.changeregion() },
            { id: 'logout', label: this.currLangTranslation.navbar.logout, icon: 'pi pi-fw fa fa-power-off', command: () => this.logout() }
          ]
        },
        ];
      }
    });

   
    this.sharedService.menuClick = false;
    this.getUserPrivacyPolicy();

  }

  private updateItemsCollection() {
    if (this.items && this.items.length) {
      this.items[0].items.map((item) => {
        if (this.currLangTranslation.navbar[item.id]) {
          if (item[item.id] === this.currLangTranslation.navbar[item.id]) {
            item[item.label] = this.currLangTranslation.navbar[item.id];
          }
          return item;
        }
      });
    }
  }

  changeregion() {
    localStorage.removeItem('selectedInfra');
    localStorage.removeItem('WBcountryId');
    localStorage.removeItem('WBEngagementId');
    location.href = '/';
  }

  setPageitemlist() {
    this.pageItemlist = [
      {
        id: 'home',
        description: 'PROJECTS'
      },
      {
        id: 'engagement',
        description: 'PROJECT MANAGEMENT'
      },
      {
        id: 'viewengagement',
        description: 'View project'
      },
      {
        id: 'editengagement',
        description: 'Edit project'
      },
      {
        id: 'addengagement',
        description: 'Add project'
      },
      {
        id: 'uploadsource',
        description: 'UPLOAD'
      },
      {
        id: 'previewsourcefile',
        description: 'Preview & Attributes'
      },
      {
        id: 'inputcapture',
        description: 'USER INPUTS'
      },
      {
        id: 'mappingselection',
        description: 'ACCOUNT MAPPINGS'
      },
      {
        id: 'scenario',
        description: 'Assessment'
      },
      {
        id: 'remediation',
        description: 'Verification'
      },
      {
        id: 'performdatacheck',
        description: 'Data Check'
      },
      {
        id: 'downloaduploadflatfile',
        description: 'Flat File'
      },
      {
        id: 'schedules',
        description: 'SCHEDULES'
      },
      {
        id: 'selectadjustment',
        description: 'Select Adjustment'
      },
      {
        id: 'validations',
        description: 'Quality Checks'
      },
      {
        id: 'databook',
        description: 'Download Databook'
      },
      {
        id: 'uploaddownloadflatfile',
        description: 'Download & Upload Flat file'
      },
      {
        id: 'add',
        description: 'Add adjustments'
      },
      {
        id: 'help',
        description: 'Help'
      },
      {
        id: 'uploaddatabook',
        description: 'Upload Databook'
      },
      {
        id: 'databookdownloadconfirm',
        description: 'Download confirm'
      },
      {
        id: 'layout',
        description: 'Layout Configuration'
      },
      {
        id: 'customizedlayouts',
        description: 'Customized Layouts'
      },

    ];
  }

  public getmasterHelp(): void {
    this.masterHelpService.getMasterHelpById(this.viewProjectId)
      .subscribe((data: MasterHelpModel) => {
        this.helpMenu = data;
        // View project
        this.helpMenu.PageName = this.currLangTranslation.projectManagement.helpVideo.pageName;
        this.helpMenu.HelpContent = this.currLangTranslation.projectManagement.helpVideo.helpContent;
      });
  }

  menuShowHide() {
    this.sharedService.menuClick = !this.sharedService.menuClick;
  }

  setProjectname(name: string, locationpath: string) {
    console.log("in setProj");
    if (name === 'PROJECTS') {
      this.projectname = '';
      this.sharedService.homeMenuClick();
    } else if (name === 'REPORTS') {
      this.projectname = '';
      this.sharedService.reportsMenuClick();
    } else if (name === 'PROJECT MANAGEMENT') {
      this.projectname = 'View all projects';
      this.sharedService.engagementMenuClick('', '');
    }else if (name === 'Customized Layouts') {
      this.projectname = 'Customized layouts';
      this.sharedService.customizedLayoutMenuClick();
    }
     else if (name === 'VIEW PROJECT') {
      this.projectname = 'View project';
      this.sharedService.engagementMenuClick('', '');
    } else if (name === 'View project') {
      this.projectname = 'View project';
    } else if (name === 'Edit engagement') {
      this.projectname = 'Edit project';
    } else if (name === 'Add engagement') {
      this.projectname = 'Add new project';
    } else if (name === 'Help') {
      this.projectname = 'View help';
    } else {
      let engagementId = locationpath.split('/')[2];
      this.adjustmentPage = ' ';
      if (locationpath.split('/')[4] == 'adjustment' && locationpath.split('/')[5] == 'edit') {
        engagementId = locationpath.split('/')[3];
        this.adjustmentPage = 'Edit Adjustment';
        this.adjustmentID = locationpath.split('/')[2];
      } else if (locationpath.split('/')[3] == 'adjustment' && locationpath.split('/')[4] == 'add') {
        this.adjustmentPage = 'Add Adjustment';
      } else if (locationpath.split('/')[1] == 'adjustment' && locationpath.split('/')[2] == 'view') {
        engagementId = locationpath.split('/')[4];
        this.adjustmentPage = 'View Adjustment';
        this.adjustmentID = locationpath.split('/')[3];
      }

      if (parseInt(this.adjustmentID)) {
        this.adjustmentService.getAdjustment(parseInt(this.adjustmentID))
          .subscribe((data: AdjustmentModel) => {
            this.adjustmentName = data.adjustmentName;
            this.engagementId = data.engagementId.toString();
          });
      }

      if (this.isNumber(engagementId)) {
        const countryId = localStorage.getItem('WBcountryId');
        console.log("in getEng",countryId);
        console.log("currentitem",this.currentitem);
        if(countryId != undefined && countryId != "null"){
          console.log("do nothing..");
        }
        else {
          console.log("get engagement header component call");
        this._engagementservice.getEngagement(parseInt(engagementId)).subscribe((data: EngagementModel) => {
          if (data !== null) {
            this.projectname = data.EngagementName;
            localStorage.setItem('currentEngagement' + engagementId + this.regionId, this.projectname);
            localStorage.setItem('currentEngagementTemplateId' + this.regionId + data.Id, `${data.TemplateId}`);
            
          }
        });
        this.projectname = localStorage.getItem('currentEngagement' + engagementId + this.regionId);
      }
      } else {
        if (engagementId === 'view') {
          this.projectname = 'View Adjustment';
        } else {
          this.projectname = 'My Project';
        }
      }
 
    }
  }

  logout() {
    this._engagementservice.updateAuthenticationTokenDetails().subscribe();
    localStorage.clear();
    location.href = '/';
    this.adalSvc.logout();
  }

  isNumber(n) { return /^-?[\d.]+(?:e-?\d+)?$/.test(n); }

  getUserPrivacyPolicy() {
    this.userService.cast.subscribe((userData: UserModel) => {
      if (userData !== undefined) {
        this.isPrivacyPolicyAgreed = userData.IsPrivacyPolicyAgreed;
      }
    });
  }

  showLoadDialog(inputElement) {
    let displayContent;
    if (inputElement?.target) {
      const inputCheckboxSelected: boolean = inputElement.target.checked;
      displayContent = inputCheckboxSelected ? false : true;
      this.activeIndex = this.sharedService.getLocalStorageValueByName('activeindex');
      let masterHelpId;
      if(this.currentitem === 'Data Check' || this.currentitem === 'SCHEDULES'){
         masterHelpId = this.helpMenu2.StepId + 1;
      }
      else { 
        masterHelpId = this.activeIndex + 1;
      }
      this.masterHelpService.UpdatedHelpById(masterHelpId, displayContent).subscribe((updatedData) => {
      });
    }
  }

  showVideo() {
    this.helpMenu.DisplayContent = false;
    this.videoPopUpModelSmall = false;
    // video popup model for to enable play video
    this.videoPopUpModel = true;
    this.masterHelpService.getMasterHelpById(this.viewProjectId)
      .subscribe((data: MasterHelpModel) => {
        this.helpMenu1 = data;
      });
  }

  showHelpVideo() {
    this.helpMenu.DisplayContent = false;
    this.display = false;
    this.videoPopUpModelSmall = false;
    this.videoPopUpModel = true;
    this.masterHelpService.getMasterHelpById(this.viewProjectId)
      .subscribe((data: MasterHelpModel) => {
        this.helpMenu2 = data;
      });
  }

  showDialog() {
    if (this.currentitem === 'Layout Configuration') {
      if(this.applnLang.isoCode === 'en-US') {
        window.open(this.pnpEnglishHelpGuidURL, "_blank");
      }
      else if (this.applnLang.isoCode === 'es-ES') {
        window.open(this.pnpSpanishHelpGuidURL, "_blank");
      }
      return;
    }
   
    this.display = true;
    this.isTempFlatfileUploaded = this.sharedService.getLocalStorageValueByName('isTempFlatfileUploaded' + this.engagementId +
      this.regionId);
    this.getmasterHelp1();
  }

  public openHelpGuide() {
    if (this.applnLang.ISOCode === 'en-US') {
      window.open(this.helpGuideEnglish, "_blank");
    }
    else if (this.applnLang.ISOCode === 'es-ES') {
      window.open(this.helpGuideSpanish, "_blank");
    }

  }


  public getmasterHelp1() {
    let activeIndex: number;
    if (this.isTempFlatfileUploaded === 1 && this.currentitem === 'Verification') {
      activeIndex = 5;
    } else if (this.isTempFlatfileUploaded === 1 && this.currentitem === 'ACCOUNT MAPPINGS') {
      activeIndex = 4;
    } else if (this.isTempFlatfileUploaded === 1 && this.currentitem === 'Data Check') {
      activeIndex = 6;
    } else if (this.isTempFlatfileUploaded === 1 && this.currentitem === 'SCHEDULES') {
      activeIndex = 7;
    } else {
      activeIndex = this.sharedService.getLocalStorageValueByName('activeindex');
    }
    this.masterHelpService.getMasterHelp(activeIndex).subscribe((data: MasterHelpModel) => {
      this.helpMenu2 = data;

      switch (this.currentitem) {
        case "UPLOAD":
          // Upload
          this.helpMenu2.PageName = this.currLangTranslation.step1.helpVideo.pageName;
          this.helpMenu2.HelpContent = this.currLangTranslation.step1.helpVideo.helpContent;
          break;
        case "Preview & Attributes":
          // Preview & attributes
          this.helpMenu2.PageName = this.currLangTranslation.step2.helpVideo.pageName;
          this.helpMenu2.HelpContent = this.currLangTranslation.step2.helpVideo.helpContent;
          break;
        case "USER INPUTS":
          // User inputs
          this.helpMenu2.PageName = this.currLangTranslation.step3.helpVideo.pageName;
          this.helpMenu2.HelpContent = this.currLangTranslation.step3.helpVideo.helpContent;
          break;
        case "Assessment":
          // Assessment
          this.helpMenu2.PageName = this.currLangTranslation.step4.helpVideo.pageName;
          this.helpMenu2.HelpContent = this.currLangTranslation.step4.helpVideo.helpContent;
          break;
        case "ACCOUNT MAPPINGS":
          // Account Mapping
          this.helpMenu2.PageName = this.currLangTranslation.step5.helpVideo.pageName;
          this.helpMenu2.HelpContent = this.currLangTranslation.step5.helpVideo.helpContent;
          break;
        case "Verification":
          //Verification
          this.helpMenu2.PageName = this.currLangTranslation.step6.helpVideo.pageName;
          this.helpMenu2.HelpContent = this.currLangTranslation.step6.helpVideo.helpContent;
          break;
        case "Data Check":
          // Data check
          this.helpMenu2.PageName = this.currLangTranslation.step7.helpVideo.pageName;
          this.helpMenu2.HelpContent = this.currLangTranslation.step7.helpVideo.helpContent;
          break;
        case "SCHEDULES":
          // Schedules
          this.helpMenu2.PageName = this.currLangTranslation.step8.helpVideo.pageName;
          this.helpMenu2.HelpContent = this.currLangTranslation.step8.helpVideo.helpContent;
          break;
        case "Download & Upload Flat file":
          // Download & Upload Flat file
          this.helpMenu2.PageName = this.currLangTranslation.step1.helpVideo.pageNameTemplate;
          this.helpMenu2.HelpContent = '';
          break;
        default:
          break;
      }
    });
  }

  showVideoMinimize() {
    this.videoPopUpModelSmall = true;
    this.videoPopUpModel = false;
  }

  private updateHelp(displayContent: boolean): void {
    this.masterHelpService.UpdatedHelpById(this.viewProjectId, displayContent).subscribe((updatedData) => {
    });
  }

  OnhideDialogPopUp1() {
    this.helpMenu.DisplayContent = !this.helpMenu.DisplayContent;
    this.updateHelp(this.helpMenu.DisplayContent);
  }

  OnhideDialogPopUp2() {
    this.helpMenu1.DisplayContent = !this.helpMenu1.DisplayContent;
    this.updateHelp(this.helpMenu1.DisplayContent);
  }

  showVideoMaximize() {
    this.videoPopUpModelSmall = false;
    this.videoPopUpModel = true;

  }

  hideVideoMinimize() {
    this.videoPopUpModelSmall = false;
  }

  private getPageName(urlList: Array<any>) {
    if (urlList.length) {
      for (let i = urlList.length - 1; i >= 0; i--) {
        if (!this.isNumber(urlList[i].path)) {
          return urlList[i].path;
        }
      }
    }
  }
}
